import React from 'react'

const Spacer = ({height}: {height: number}) => {
    return(
        <div style={{height:height}}></div>
    )
}

export default Spacer